export const createId = (base = '', ...args: (string | number)[]) =>
  args.reduce((result, item) => `${result}-${item}`, base).toString()
